import React from "react";
import './Home.css';

const Home = () => {
  return (
    <div><p>Home</p></div>
  )
}

export default Home;